export const Sort = () => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.62865 7.90209L3.99344 13.3143L0.412354 7.90209H7.62865Z" fill="#40444D" />
    <path d="M4.0205 0.685791L0.412354 6.09801H7.62865L4.0205 0.685791Z" fill="#40444D" />
  </svg>
);
